import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TutorialManagement, TutorialSettings } from '@maporium-workspace/shared';

@Injectable({
  providedIn: 'root'
})
export class TutorialResource {
  private readonly baseUrl = environment.apiUrl + '/tutorials';

  constructor(private http: HttpClient) {}

  getTutorials(): Observable<TutorialSettings | null> {
    return this.http.get<TutorialSettings | null>(this.baseUrl);
  }

  getTutorialById(id: string): Observable<TutorialManagement | null> {
    return this.http.get<TutorialManagement | null>(`${this.baseUrl}/${id}`);
  }

  createTutorial(tutorial: Omit<TutorialManagement, 'id' | 'createdAt' | 'updatedAt'>): Observable<TutorialManagement> {
    return this.http.post<TutorialManagement>(this.baseUrl, tutorial);
  }

  updateTutorial(id: string, updates: Partial<TutorialManagement>): Observable<TutorialManagement | null> {
    return this.http.put<TutorialManagement | null>(`${this.baseUrl}/${id}`, updates);
  }

  deleteTutorial(id: string): Observable<{ success: boolean }> {
    return this.http.delete<{ success: boolean }>(`${this.baseUrl}/${id}`);
  }

  toggleTutorialStatus(id: string): Observable<TutorialManagement | null> {
    return this.http.put<TutorialManagement | null>(`${this.baseUrl}/${id}/toggle`, {});
  }

  reorderTutorials(tutorialIds: string[]): Observable<TutorialManagement[]> {
    return this.http.post<TutorialManagement[]>(`${this.baseUrl}/reorder`, { tutorialIds });
  }

  saveTutorialSettings(settings: TutorialSettings): Observable<TutorialSettings> {
    return this.http.post<TutorialSettings>(`${this.baseUrl}/settings`, settings);
  }
}